import { filterAvailableTimes } from '@myfunnow/web-core/time-filter'

import { FilterTypes, CategorySortKey } from '@/constants/filters'
import type { Filter, FilterTag } from '@/view-models/filters'
import { getIsCategoryPageQueryStringValid } from '@/utils/utils'

export function getCategorySelectedFilterTagMapFromQueryString(
  filterTagsQueryString: string,
  filterTags: FilterTag[] = []
): Record<string, number[]> {
  if (!filterTagsQueryString) {
    return {}
  }
  try {
    const tagGroupsTagsFromQueryString = JSON.parse(filterTagsQueryString)
    const tagsFromQueryString = Array.isArray(tagGroupsTagsFromQueryString) ? tagGroupsTagsFromQueryString.flat(1) : []

    return filterTags.reduce((selectedTagsObject, tagGroup) => {
      const selectedTagIds = tagGroup.tags.filter(tag => tagsFromQueryString.includes(tag.id)).map(tag => tag.id)

      selectedTagsObject = {
        ...selectedTagsObject,
        [tagGroup.title]: selectedTagIds,
      }
      return selectedTagsObject
    }, {})
  } catch (error) {
    console.error('parse filter tags from query string error', error)
    return {}
  }
}

/**
 *
 * @param query  The query object from the nuxt context
 * @param filterOptions  The filter options from the server
 * @param hasGeolocation  Whether the user has geolocation
 */
export function getCategoryDefaultFiltersFromQuery(query: Record<string, string | unknown[]>, filterOptions?: Filter, hasGeolocation?: boolean) {
  const isSubCategoryMode = !!query.source_category_id

  const selectedFilterTagMap =
    typeof query.filter_tags === 'string' ? getCategorySelectedFilterTagMapFromQueryString(query.filter_tags, filterOptions?.filter_tags || []) : {}

  const defaultFilter = Object.keys(query).reduce((newFilterMap, key) => {
    let queryValue = query[key]
    if (!queryValue) {
      return newFilterMap
    }

    switch (key) {
      case FilterTypes.FILTER_TAGS: {
        const validTagGroups = Object.values(selectedFilterTagMap).filter(selectedTagIds => selectedTagIds.length > 0)
        if (validTagGroups.length === 0) {
          return newFilterMap
        }
        queryValue = JSON.stringify(validTagGroups)
        break
      }
      case FilterTypes.SORTBY:
        if ([CategorySortKey.POPULAR_OVER_DISTANCE, CategorySortKey.DISTANCE].includes(queryValue as CategorySortKey) && !hasGeolocation) {
          queryValue = CategorySortKey.POPULAR
        }
        break
      case FilterTypes.FILTER_KEYWORD:
        queryValue = isSubCategoryMode ? '' : queryValue
        break
      case FilterTypes.FILTER_TIMES: {
        if (!Array.isArray(queryValue)) {
          queryValue = [queryValue]
        }
        const startTime = query[FilterTypes.START_TIME]

        if (typeof startTime === 'string' && startTime) {
          queryValue = filterAvailableTimes(queryValue as string[], startTime)
        }
        break
      }
      default:
        break
    }

    const isValid: boolean = getIsCategoryPageQueryStringValid(key, queryValue, filterOptions)

    if (isValid) {
      newFilterMap[key as FilterTypes] = queryValue
    }
    return newFilterMap
  }, {} as Partial<Record<FilterTypes, string | unknown[]>>)

  if (!defaultFilter[FilterTypes.START_TIME]) {
    const { endtime, ...filter } = defaultFilter
    return filter
  }

  return defaultFilter
}
